import {
    DEFAULT_IMAGE_RESIZING_OPTIONS,
    getStorageImageResizedURL,
    type StorageImageResizingOptions,
} from '@gitbook/app-database';

/**
 * Compute a url to a resized version of an image with automatic dpr for the current device/
 */
export function getImageResizedURL(
    inputUrl: string,
    options?: Omit<StorageImageResizingOptions, 'dpr'>
): string {
    return getStorageImageResizedURL(inputUrl, {
        ...DEFAULT_IMAGE_RESIZING_OPTIONS,
        ...options,
    });
}
